import ControlledCheckboxGroup from '@@viewCommonComponents/controlled/ControlledCheckBoxGroup.jsx';
import { offerCodeEnum } from '@@viewEnums';
import useSaveExtraSimulationRecapCustomerAgreementMutation from '@@views/simulationRecap/client/hooks/useSaveExtraSimulationRecapCustomerAgreementMutation';

const ExtraForm = ({ form, offerCode }) => {
  const { onFormSubmit: saveExtraCustomerAgreement } =
    useSaveExtraSimulationRecapCustomerAgreementMutation();

  const saveAgreement = () => {
    const data = {
      customerAgreement: form.watch('collectionNeeds.0.customerAgreement')
    };
    saveExtraCustomerAgreement(data);
  };

  if (offerCode !== offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION) {
    return null;
  }

  return (
    <ControlledCheckboxGroup
      extraOnChange={saveAgreement}
      name={'collectionNeeds.0.customerAgreement'}
      options={[
        {
          label: 'J’accepte la proposition préconisée par mon conseiller.',
          value: true
        },
        {
          label:
            'Je ne choisis pas la proposition effectuée par mon conseiller. Je suis informé(e) que j’ai la possibilité d’adapter mes choix en réalisant un nouveau devis.',
          value: false
        }
      ]}
      form={form}
      containerClassName="flex flex-col font-normal mt-2 mb-12 gap-4"
    />
  );
};

export default ExtraForm;
